import { cn } from 'lib/helpers/utility';

import Container from 'components/shared/Container/Container';

import StepperContent from '../StepperContent/StepperContent';
import StepperSidebar from '../StepperSidebar/StepperSidebar';

const StepperLayout = ({
  stepsState,
  phases,
  sidebarType,
  hiddenSubstepCodes,
  restrictedStepsCodes,
  isNarrowScreen,
  sidebarOpen,
  closeSidebar,
  isEnteringFromIntro,
  smartSuggestions,
  isAdmin,
  practice,
  sidebarComponentProps,
  mainContentRef,
  wizardState,
  onExpandStep,
  onCollapseStep,
  onActivateStep,
  onNavigateSubstep,
  headerProps,
  footerProps,
  stepProps
}) => (
  <div className="h-screen bg-gradient-to-b from-primary-50 to-primary-200 p-10 md:px-6 md:py-8">
    <div className="relative flex h-full justify-center gap-10 xs:p-0 md:gap-6">
      <StepperSidebar
        stepsState={stepsState}
        phases={phases}
        sidebarType={sidebarType}
        hiddenSubstepCodes={hiddenSubstepCodes}
        restrictedStepsCodes={restrictedStepsCodes}
        isNarrowScreen={isNarrowScreen}
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isEnteringFromIntro={isEnteringFromIntro}
        smartSuggestions={smartSuggestions}
        isAdmin={isAdmin}
        practiceId={practice?.id}
        onExpandStep={onExpandStep}
        onCollapseStep={onCollapseStep}
        onActivateStep={onActivateStep}
        onNavigateSubstep={onNavigateSubstep}
        {...sidebarComponentProps}
      />

      <Container
        className={cn(
          'stepper-main-content relative mx-0 w-full justify-center overflow-hidden rounded-xl bg-white xs:px-0',
          isEnteringFromIntro && 'entering'
        )}
        onClick={closeSidebar}>
        <StepperContent
          isAdmin={isAdmin}
          isNarrowScreen={isNarrowScreen}
          isEnteringFromIntro={isEnteringFromIntro}
          mainContentRef={mainContentRef}
          wizardState={wizardState}
          practice={practice}
          headerProps={headerProps}
          footerProps={footerProps}
          stepProps={stepProps}
        />
      </Container>
    </div>
  </div>
);

export default StepperLayout;
